import { render, staticRenderFns } from "./SendNotification.vue?vue&type=template&id=a02b6308&scoped=true"
import script from "./SendNotification.vue?vue&type=script&lang=js"
export * from "./SendNotification.vue?vue&type=script&lang=js"
import style0 from "./SendNotification.vue?vue&type=style&index=0&id=a02b6308&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02b6308",
  null
  
)

export default component.exports